/**
 * How the shop takes orders.
 *
 * false: every speaker is ordered through the waiting list — no cart, no
 * payment, SonicBeats follows up by email. true: the reserve-a-slot cart and
 * Stripe checkout come back. The checkout code is untouched either way, so
 * this is the only switch.
 */
export const CHECKOUT_ENABLED = false;
